/* global mixpanel */
function getOutletsFromEmployee ({employee, outlets}) {
  const assignedOutletIds = {}
  employee.outlets.forEach(oid => { assignedOutletIds[oid] = true })
  const assignedOutlets = []
  outlets.forEach((o) => {
    if (assignedOutletIds.hasOwnProperty(o.id)) {
      assignedOutlets.push({id: o.id, name: o.name})
    }
  })
  return assignedOutlets
}

export function inviteStaff ({employee, outlets, role}) {
  const data = {
    'Image': employee.photo_url,
    'First Name': employee.first_name,
    'Last Name': employee.last_name,
    'Email': employee.email,
    'Phone Number': employee.phone,
    'Role': role.name,
    'PIN': employee.pin,
    'Outlet': getOutletsFromEmployee({employee, outlets}),
    'Description': employee.description
  }
  mixpanel.track('Invite New Staff', data)
}

export function editStaff ({employee, outlets, role}) {
  const data = {
    'Image': employee.photo_url,
    'First Name': employee.first_name,
    'Last Name': employee.last_name,
    'Email': employee.email,
    'Phone Number': employee.phone,
    'Role': role.name,
    'PIN': employee.pin,
    'Outlet': getOutletsFromEmployee({employee, outlets}),
    'Description': employee.description
  }
  mixpanel.track('Edit Staff', data)
}

export function deleteStaff () {
  mixpanel.track('Delete Staff')
}



// WEBPACK FOOTER //
// ./app/mixpanel/employees/staff.js